import { Component, h, Prop } from '@stencil/core';

import { BaseChart, IChartTitle } from '../../models';

// local component constant
enum TITLE_TYPE {
  TITLE,
  SUB_TITLE
}

@Component({
  tag: 'uui-chart-title',
  styleUrl: 'uui-chart-title.scss',
  shadow: false,
  scoped: true
})
export class UuiChartTitle {
  @Prop() model: BaseChart;

  getTitleElement(title: IChartTitle, type: TITLE_TYPE): JSX.Element {
    return title.useSlot ? (
      <slot name={type === TITLE_TYPE.SUB_TITLE ? 'sub-title' : 'title'} />
    ) : type === TITLE_TYPE.SUB_TITLE ? (
      <p class="chart-sub-title">{title.text}</p>
    ) : (
      <h3 class="chart-title">{title.text}</h3>
    );
  }

  render() {
    return (
      <div class="chart-title-container ">
        {this.model.title &&
          this.getTitleElement(this.model.title, TITLE_TYPE.TITLE)}
        {this.model.subTitle &&
          this.getTitleElement(this.model.subTitle, TITLE_TYPE.SUB_TITLE)}
      </div>
    );
  }
}
